export default "__VITE_ASSET__BBl5CZ5f__"